<template>
    <el-dialog title="Tareas programadas"
        :visible="showDialog"
        @open="loadDetails"
        @close="close"
    >
        <div class="row">
            <div class="col-12" v-loading="loading">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Clase</th>
                                <th class="text-center">Hora de ejecución</th>
                                <th class="text-center">Última ejecución</th>
                                <th class="text-center" width="200">Log</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="!tasks.length">
                                <tr>
                                    <td colspan="4">
                                        No hay registros
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="task in tasks">
                                    <td>{{ task.class }}</td>
                                    <td class="text-center">{{ task.execution_time }}</td>
                                    <td class="text-center">{{ task.updated_at }}</td>
                                    <td width="200">{{ task.output }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <el-pagination
                    :total="pagination.total"
                    :current-page.sync="pagination.current_page"
                    :page-size="pagination.per_page"
                    @current-change="loadDetails"
                    layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "ModalDetails",
        props: {
            showDialog: {
                type: Boolean,
                default: false
            },
            dataItem: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                tasks: [],
                pagination: {}
            }
        },
        methods: {
            close() {
                this.$emit('update:showDialog', false)
                this.tasks = []
                this.pagination = {}
            },

            async loadDetails() {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(`/scheduled-tasks/record-by-client/${this.dataItem.id}`,{
                        params: {
                            page: this.pagination.current_page
                        }
                    })
                    this.tasks = data.data
                    this.pagination = data.meta
                } catch (error) {
                    
                } finally {
                    this.loading = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/scheduled_task/components/ModalDetails.vue